import * as React from "react";
import {cs} from "../../../../../react/chain-services";
import "./chip.scss";

export const Chip = ({backgroundColor="rgba(51, 65, 80, 0.75)", textColor="#FFFFFF", text, onClose, xdQaName="chip"}) => cs(
    () => (
        <div className="chip-nd3">
            <div className="item" xd-qa-type="badge" xd-qa-name={xdQaName} style={{ "--chip-bg": backgroundColor }}>
                <div className="text" xd-qa-type="label" xd-qa-name="Selected" style={{ "--chip-text": textColor }}>
                    {text}
                </div>

                <div
                    className="close"
                    onClick={onClose}
                    xd-qa-type="icon"
                    xd-qa-name="Remove"
                >&times;</div>
            </div>
        </div>
    ),
);